import * as messageService from "../../services/message.service";
import * as maturingLeasService from '../../services/maturingLeas.service';


const state = {
    maturingLeasPaginate:{},
    maturingLeasPaginateData:{},
};

const getters = {
    getMaturingLeasPaginate:state => (state.maturingLeasPaginate),
    getMaturingLeasPaginateData:state => (state.maturingLeasPaginateData),
};

const actions = {
    async fetchMaturingLeasPaginate({ commit }, obj){
        commit('setMaturingLeasPaginate', obj)
        try {
            const response = await maturingLeasService.listPage(obj);

            commit('setMaturingLeasPaginateData', response.data);
            
        } catch (error) {
            console.log('something wrong - fetchMaturingLeasPaginate', error);
        }
    },
};

const mutations = {
    setMaturingLeasPaginateData:(state, res) => (
        state.maturingLeasPaginateData =  res
    ),
    setMaturingLeasPaginate:(state, res) => (
        state.maturingLeasPaginate =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}